import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ListItemDetails from './ListItemDetails';
import { Link } from 'react-router-dom';

const ListingModal = (props) => {
  const handleHide = () => {
    props.setShowModal(false);
  };
  return (
    <Modal
      show={props.showModal}
      onHide={handleHide}
      container={this}
      aria-labelledby='contained-modal-title'
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title'>
          {console.log('selectedListing', props.selectedListing)}
        {(props.selectedListing.locationGroupTitle) ? props.selectedListing.locationGroupTitle : props.selectedListing.listingAddress}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>        
        <ListItemDetails listingId={props.selectedListing.listingId} />
      </Modal.Body>
      <Modal.Footer>
        <Link to={`/bookmark/${props.selectedListing.listingId}`} style={({ marginRight: `20px`})}>Open as a link</Link>
        <Button onClick={handleHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ListingModal;